import { request } from "../client";

import type {
  CreatePaymentIntentRequest,
  CreatePaymentIntentResponse,
  ConfirmPaymentRequest,
  ConfirmPaymentResponse,
  PaymentHistoryResponse,
  AdminRefundResponse,
} from "../types/payments";

export function createPaymentsEndpoints(baseUrl: string): {
  createIntent: (
    payload: CreatePaymentIntentRequest,
    token?: string | null,
  ) => Promise<CreatePaymentIntentResponse>;
  confirm: (
    payload: ConfirmPaymentRequest,
    token?: string | null,
  ) => Promise<ConfirmPaymentResponse>;
  history: (
    token?: string | null,
    offset?: number,
    limit?: number,
  ) => Promise<PaymentHistoryResponse>;
  adminRefund: (
    paymentId: string,
    reason?: string,
    token?: string | null,
  ) => Promise<AdminRefundResponse>;
} {
  return {
    createIntent(
      payload: CreatePaymentIntentRequest,
      token?: string | null,
    ): Promise<CreatePaymentIntentResponse> {
      return request<CreatePaymentIntentResponse>(baseUrl, "/payments/intent", {
        method: "POST",
        body: payload,
        token,
      });
    },
    confirm(
      payload: ConfirmPaymentRequest,
      token?: string | null,
    ): Promise<ConfirmPaymentResponse> {
      return request<ConfirmPaymentResponse>(baseUrl, "/payments/confirm", {
        method: "POST",
        body: payload,
        token,
      });
    },
    history(
      token?: string | null,
      offset = 0,
      limit = 20,
    ): Promise<PaymentHistoryResponse> {
      return request<PaymentHistoryResponse>(baseUrl, "/payments/history", {
        method: "GET",
        query: { offset, limit },
        token,
      });
    },

    // Admin: refund payment by ID
    adminRefund(
      paymentId: string,
      reason?: string,
      token?: string | null,
    ): Promise<AdminRefundResponse> {
      return request<AdminRefundResponse>(
        baseUrl,
        `/payments/admin/refund/${encodeURIComponent(paymentId)}`,
        {
          method: "POST",
          body: reason ? { reason } : {},
          token,
        },
      );
    },
  };
}
